import { MAPBOX_ACCESS_TOKEN } from '../const/environments.constants';

const MAPBOX_GEOCODING_BASE = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

interface GeocodingOptions {
    limit?: number;
    language?: string;
}

export const getGeocodingUrl = (query: string, options?: GeocodingOptions): string => {
    const { limit = 5, language = 'es' } = options || {};
    return `${MAPBOX_GEOCODING_BASE}/${encodeURIComponent(query)}.json?access_token=${MAPBOX_ACCESS_TOKEN}&limit=${limit}&language=${language}`;
};
